export const orderDetailActions = () => {
	if (document.querySelector('.online-order-status-detail') !== null) {
		$('.popLabelsBtn').on('click', function () {
			var thisButton = $(this);
			var thisButtonId = thisButton[0].dataset.buttonid;
			var thisPopContainer = thisButton
				.closest('tr[data-twist=' + thisButtonId + ']')
				.next('tr')
				.find('div.popImageContainer');
			thisButton.text(thisButton.text() === 'View Proof of Purchase Labels' ? 'Hide Proof of Purchase Labels' : 'View Proof of Purchase Labels');
			thisButton.attr('aria-expanded', thisButton.attr('aria-expanded') === 'false' ? 'true' : 'false');
			thisPopContainer.toggleClass('hidden');
		});
	}

	if (document.querySelector('.online-order-status-detail') !== null) {
		const storeReturnBtn = document.getElementById('storeReturnSubmit');
		if (storeReturnBtn !== null) {
			storeReturnBtn.addEventListener('click', () => {
				const popNumbers = document.querySelectorAll('.popLabelImage');
				let popsToSend = '';
				if (popNumbers.length > 0) {
					for (let x = 0; x < popNumbers.length; x++) {
						popsToSend += popNumbers[x].dataset.pop + ',';
					}
					if (popsToSend !== '') {
						const returnsUrl = '/store-purchase-returns?popNumbers=' + popsToSend.slice(',', -1);
						location.href = returnsUrl;
					}
				}
			});
		}
	}

	// call to get the pops associated with a store order: adds a click handler to the store orders' "start a return" button, gets the pops, and adds them to store returns url
	if (document.querySelector('.purchase-history-page') !== null) {
		const returnButtons = document.querySelectorAll('.rtn-store');
		if (returnButtons.length > 0) {
			returnButtons.forEach((button) => {
				button.addEventListener('click', callOrderPopLabels);
			});
		}
	}

	function callOrderPopLabels(event) {
		const thisButton = event.target;
		const orderStore = '?store=' + thisButton.dataset.orderStore;
		const orderReg = '&reg=' + thisButton.dataset.orderReg;
		const orderTran = '&tran=' + thisButton.dataset.orderTran;
		const orderDate = '&date=' + thisButton.dataset.orderDate;
		const popLabelUrl = '/wcs/resources/store/301/purchaseHistory/orderDetail/popLabels' + orderStore + orderReg + orderTran + orderDate;
		$.ajax({
			type: 'GET',
			url: popLabelUrl,
			success: (data) => {
				const popResponse = data.response.popLabels;
				if (popResponse.length > 0) {
					const popString = popResponse.join(',');
					const returnsUrl = '/store-purchase-returns?popNumbers=' + popString;
					location.href = returnsUrl;
				} else {
					location.href = '/store-purchase-returns';
				}
			},
			error: () => {
				location.href = '/store-purchase-returns';
			},
		});
	}
};
